import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { pairwise, startWith } from 'rxjs/operators';
import { AppService } from 'src/app/services/app.service';
import { EntrepriseInfoDialog } from 'src/app/views/dialog-entreprise/dialog-entreprise-info.component';
import { DialogCommonError } from 'src/app/views/dialogs-errors/dialog-common-error.component';
import { DialogsInitPayslipComponent } from 'src/app/views/dialogs-init-payslip/dialogs-init-payslip.component';
import { MessConfirmAbandon } from 'src/app/views/dialogs-messages/mess_confirmabandon_dialog.component';

@Component({
  selector: 'dossier-tab-identity',
  templateUrl: './dossier-tab-identity.component.html',
  styleUrls: ['../../views/dossier-post/dossier-post.component.scss']
})
export class DossierTabIdentityComponent implements OnInit {
  @Input() dossier: any;
  @Input() contrats: any;
  @Input() motifs: any;
  @Input() helperOn: any;
  @Input() consumeToken: any;
  @Input() formGroup: FormGroup
  @Input() libellAndToolTip: any;
  @Input() delegation: boolean = false;
  @Input() dateAncienneteBS: any = null;
  @Output() setDataEmitter = new EventEmitter<any>();
  @Output() actionEmitter = new EventEmitter<any>();

  regexSiret = /^[0-9]{14}$/;
  siretIsValid: any = false;
  buttonSiretIsClicked: boolean = false;
  subscribe: any = [];
  errorPappers = false;
  dataFromUploadedFile = null;
  dateRuptFalse: boolean = false;
  dateContSalaFalse: boolean = false;
  dateSortieFalse: boolean = false;
  required: any = [];
  dateErr : any = {};


  constructor(
    private cdf: ChangeDetectorRef,
    private appService: AppService,
    public dialog: MatDialog,
    private router: Router
  ) {

  }

  ngOnInit() {
    this.updateSiret();
    this.testDateErr()
    this.initContrat();
  }

  toggleChipMotif(chip, event = null) {
    if (!event || event.keyCode == 32) {
      this.motifs.forEach(c => {
        chip.Value !== c.Value ? c.selected = false : c.selected = true;
        if (c.selected) {
          let boolMaladie = this.formGroup.get("maladieSala");
          // this.updatePeriodAfterInput();
          this.formGroup.get("motifSala").setValue(c.Value);
          //this.changeInput('motifSala', this.formGroup)
          if (c.Value == "LICENCIEMENT PERS") {
            // this.affectDateRupt("DT_LIC_PERS")
            this.formGroup.get("nomDateRupt").setValue("DT_LIC_PERS");
          } else if (c.Value == "LICENCIEMENT ECO") {
            // this.affectDateRupt("DT_LIC_ECO")
            this.formGroup.get("nomDateRupt").setValue("DT_LIC_ECO");
          } else if (c.Value == "RC") {
            // this.affectDateRupt("DT_LIC_RC")
            this.formGroup.get("nomDateRupt").setValue("DT_LIC_RC");
            boolMaladie.setValue("FALSE");
          } else if (c.Value == "DEMISSION") {
            // this.affectDateRupt("DT_DEM")
            this.formGroup.get("nomDateRupt").setValue("DT_DEM");
            boolMaladie.setValue("FALSE");
          } else {
            // this.affectDateRupt("DT_FIN_CONT")
            boolMaladie.setValue("FALSE");
            this.formGroup.get("nomDateRupt").setValue("DT_FIN_CONT");
          }
        }
      });
      this.cdf.detectChanges();
    }
  }

  initContrat() {
    const value = this.formGroup && this.formGroup.get('typeSala') && this.formGroup.get('typeSala').value;
    if(!value){
      this.contrats.forEach(contrat => {
          if (contrat.Value == "CDI") {
            this.toggleChipContrat(contrat);
          }
      });
    }
  }



  toggleChipContrat(chip, event = null) {
    console.log('event contrat', event)
    if (!event || event.keyCode == 32) {
      if (this.contrats) {
        this.contrats.forEach(c => {
          chip.Value !== c.Value ? c.selected = false : c.selected = true;
          if (c.selected) {
            this.formGroup.get("typeSala").setValue(c.Value);
            //this.changeInput('typeSala', this.formGroup);
          }
        });
      }
    }
  }

  checkInputFormat(e, field) {
    if (field == 'nameSala') {
      let value = e.target.value.split(' ').map(x => {
        //faire un replace des caractères non acceptés ??
        if (x.toLowerCase() == 'de') {
          return x.toLowerCase();
        } else {
          return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
        }
      }).join(' ');
      this.formGroup.controls[field].setValue(value);
    } else if (field == 'firstnameSala') {
      let value = e.target.value.split(' ').map(x => {
        //faire un replace des caractères non acceptés ??
        return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
      }).join(' ');
      this.formGroup.controls[field].setValue(value);
    } else if (field == 'nameEntSala') {
      let value = e.target.value.split(' ').map(x => {
        //faire un replace des caractères non acceptés ??
        return x.toUpperCase();
      }).join(' ');
      this.formGroup.controls[field].setValue(value);
    }
  }

  changeInput(input, form) {
    let formData = form.getRawValue()
    if (formData && formData[input] && this.required && this.required[input]) {
      this.required[input] = null
    }
    if (formData['motifSala'] == "RC") {
      form.get("dateRupt").setValue(form.get("dateContSortieSala").value);
      form.get("dateRupt").disable({ onlySelf: true });
    } else if (formData['boolRupt'] == "TRUE") {
      form.get("dateRupt").enable({ onlySelf: true });
    }
    this.testDateErr()
    if (input === "siret") {
      this.updateSiret();
    }

    this.cdf.detectChanges()
  }

  testDateErr() {
    this.dateErr = {};
    const fields = ['dateRupt', 'dateContSala', 'dateContSortieSala', 'dateMaladieSala'];
    fields.forEach(name => {
      const el = document.querySelector(`input[formControlName="${name}"]`) as HTMLFormElement;
      if (el && el.validity && el.validity.badInput) this.dateErr[name] = true;
    });
    this.setDataEmitter.emit({ var: this.dateErr, value: this.dateErr });
    return Object.keys(this.dateErr).length > 0;
  }

  modifyValueToggle(event, formGroup, paramForm, isModifiable = true) {
    console.log('*** modifyValueToggle', formGroup)
    if (isModifiable) {
      if (event && event.target && event.target.checked) {
        formGroup.get(paramForm).setValue("TRUE")
        if (paramForm === 'postSala')
          this.erasePreviousValue("TRUE")
        if (paramForm === "isAnonyme")
          this.siretIsValid = false;
      } else {
        formGroup.get(paramForm).setValue("FALSE")
        if (paramForm === 'postSala')
          this.computeBoolRupt("FALSE")
        else if (paramForm === 'contRompu')
          this.erasePreviousValue("TRUE")
        if (paramForm === "isAnonyme") {
          if (formGroup.get("siret").value.toString().match(this.regexSiret)) {
            this.verifySiren();
          }
        }
      }

    }
  }

  updateSiret() {
    const cleanSiret = this.cleanSiret(this.formGroup.get("siret").value);
    if (cleanSiret != null) {
      this.formGroup.get("siret").setValue(this.cleanSiret(this.formGroup.get("siret").value));
      if (cleanSiret.match(this.regexSiret)) {
        this.verifySiren();
      } else {
        this.siretIsValid = false;
      }
    } else {
      this.siretIsValid = false;
    }
  }

  cleanSiret(siretStr) {
    if (siretStr != undefined && siretStr) {
      return siretStr.toString().replace(/\s+/g, "");
    }
    return "";
  }

  verifySiren() {
    this.buttonSiretIsClicked = false;
    let siren = this.formGroup.get("siret").value.toString().slice(0, 9);
    this.subscribe["dataSiren"] = this.appService.verifySiren(siren).subscribe(
      (res) => {
        if (res.result.error) {
          if (res.result.error.includes("404")) {
            this.siretIsValid = false;
            this.errorPappers = false;
            console.log("Erreur 404");
          } else if (res.result.error.includes("503")) {
            this.errorPappers = true;
            this.siretIsValid = false;
            console.log("Rien marche");
          } else { // Peut-être gérer le 401 (token non valide)
            this.errorPappers = true;
            this.siretIsValid = false;
            console.log("Erreur 401 ou autre ?");
          }
        } else {
          if (res.result.resultats.length > 0) {
            this.siretIsValid = true;
            this.errorPappers = false;
            console.log("ça marche :: ", res.result.resultats)
            if (res.result.resultats[0].nom_entreprise && !this.formGroup.get('nameEntSala').value) {
              this.formGroup.get('nameEntSala').setValue(res.result.resultats[0].nom_entreprise);
            }
          }
        }
        this.cdf.detectChanges();
      }
    );
  }

  openModalInitDossPayslip() {
    const dialogRef = this.dialog.open(DialogsInitPayslipComponent, {
      width: '100%',
      panelClass: ["container", "read-documents-dialog"],
      data: {
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.onFileUploaded(result);
      }
    });
  }

  onFileUploaded(event: any) {
    this.required = [];
    const res = event;
    const arrayCode = [
      'CIV_SAL',
      'NOM_COMPL_SAL',
      'NOM_EMP',
      'SIRET',
      'DT_ENT_BS',
      'DT_S_BS',
      'DT_ANC_BS',
    ];
    const values = this.getDataFromRecoResponse(arrayCode, res);

    this.dataFromUploadedFile = {
      directory: res.directory,
      filename: res.filename,
      url: '/' + res.url,
      validation: res.validation,
      result: res,
    };

    if (values['CIV_SAL']) {
      const civilite = values['CIV_SAL'];
      if (civilite === 'Mr' || civilite === 'Monsieur') values['CIV_SAL'] = 'M';
      else if (civilite === 'Mrs' || civilite === 'Madame') values['CIV_SAL'] = 'F';
      else values['CIV_SAL'] = '';
    }

    if (values['NOM_COMPL_SAL']) {
      let identityValues = values['NOM_COMPL_SAL'].split(' ').filter((n: string) => n);
      const identity = { nom: identityValues[0], prenom: '' };
      for (let idx = 1; idx < identityValues.length; idx++) {
        identity.prenom += identityValues[idx];
        if (identityValues.length - 1 !== idx) identity.prenom += ' ';
      }
      values['NOM_COMPL_SAL'] = identity;
    }

    this.formGroup.get('civiliteSala').setValue(values['CIV_SAL'] || '');
    this.formGroup.get('firstnameSala').setValue(values['NOM_COMPL_SAL'].prenom || '');
    this.formGroup.get('nameSala').setValue(values['NOM_COMPL_SAL'].nom || '');
    this.formGroup.get('nameEntSala').setValue(values['NOM_EMP'] || '');
    this.formGroup.get('siret').setValue(values['SIRET'] || '');
    this.formGroup.get('dateContSala').setValue('');
    this.formGroup.get('dateContSortieSala').setValue('');

    if (values['SIRET'].toString().match(this.regexSiret)) {
      this.verifySiren();
    }

    try {
      if (values['DT_ENT_BS']) {
        this.formGroup.get('dateContSala').setValue(this.fromDateToString(values['DT_ENT_BS']).split('T')[0]);
      }
      if (!values['DT_ENT_BS'] && values['DT_ANC_BS']) {
        this.dateAncienneteBS = new Date(this.fromDateToString(values['DT_ANC_BS'].split('T')[0])).toLocaleDateString('fr-FR');
      }
      if (values['DT_S_BS']) {
        this.formGroup.get('dateContSortieSala').setValue(this.fromDateToString(values['DT_S_BS']).split('T')[0]);
        this.computeBoolRupt('FALSE');
        if (this.formGroup.get('postSala').value === 'TRUE') {
          this.formGroup.get('postSala').setValue('FALSE');
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  getDataFromRecoResponse(arrayCode, response) {
    const result = {};
    const dataDoss = [];
    const values = response.validation.result.datas[0].VALUES;
    values.forEach((entete) => {
      if (entete.VALUE && entete.CODE) dataDoss[entete.CODE] = entete.VALUE;
    });
    for (let i = 0; i < arrayCode.length; i++) {
      if (dataDoss[arrayCode[i]] && !result[arrayCode[i]]) {
        result[arrayCode[i]] = dataDoss[arrayCode[i]];
      }
    }
    return result;
  }

  fromDateToString(date) {
    date = date.replaceAll(".", "-");
    date = new Date(date.toString());
    date.setTime(date.getTime() - (date.getTimezoneOffset() * 60000));
    let dateAsString = date.toISOString().substr(0, 19);
    return dateAsString;
  }

  computeBoolRupt(postSalaValue = null) {
    console.log('*** computeBoolRupt')
    let postSala = postSalaValue;
    if (!postSalaValue) {
      let doss = this.formGroup.getRawValue();
      postSala = doss.postSala;
    }
    if (postSala == "FALSE" && this.formGroup.get("contRompu").value == "FALSE")
      this.formGroup.get("contRompu").setValue("TRUE");
    if (postSala == "FALSE" || this.formGroup.get("contRompu").value == "TRUE") {
      this.formGroup.get("boolRupt").setValue("TRUE");
    } else {
      this.formGroup.get("boolRupt").setValue("FALSE");
    }
    this.cdf.markForCheck()
  }

  erasePreviousValue(postSalaValue = null) {
    console.log('*** erasePreviousValue')
    if (postSalaValue == 'TRUE') {
      // this.formGroup.get("postSala").setValue("TRUE");
      this.formGroup.get("dateContSortieSala").setValue("");
      this.formGroup.get("motifSala").setValue("");
      this.formGroup.get("contRompu").setValue("FALSE");
      this.formGroup.get("dateRupt").setValue("");
      this.formGroup.get("nomDateRupt").setValue("");
      this.formGroup.get("maladieSala").setValue("FALSE");
      this.formGroup.get("dateMaladieSala").setValue("");
    } else {
      // this.formGroup.get("postSala").setValue("FALSE");
      this.formGroup.get("contRompu").setValue("TRUE");
    }
    this.computeBoolRupt(postSalaValue);
  }

  openDialogSiret() {
    let siret = this.formGroup.get("siret").value;
    this.subscribe["dialogSiret"] = this.appService.getDataFromSiret(siret).subscribe(
      (res) => {
        if (res.result.error) {
          if (res.result.error.includes("404")) {
            const dialogRef = this.dialog.open(DialogCommonError, {
              width: '100%',
              panelClass: 'abandon-dialog',
              data: "Nous n'avons pas pu trouver d'entreprise liée à ce SIRET (" + siret + ").",
            });
          } else if (res.result.error.includes("503")) {
            const dialogRef = this.dialog.open(DialogCommonError, {
              width: '100%',
              panelClass: 'abandon-dialog',
              data: "Il y a eu un problème avec votre recherche.",
            });
          }
        } else {
          this.buttonSiretIsClicked = true;
          this.setDataEmitter.emit({ var: 'entrepriseInfo', value: res.result });
          const dialogRef = this.dialog.open(EntrepriseInfoDialog, {
            width: '100%',
            panelClass: 'siret-dialog',
            data: {
              entreprise: res.result,
              siret: siret
            }
          });
        }
      }
    )
  }

  confirmAbandon() {
    window['tryga']('send', 'event', 'dossier', 'annuler', '', '');
    if (this.dossier) {
      this.router.navigateByUrl("/dossier");
    } else {
      const dialogRef = this.dialog.open(MessConfirmAbandon, {
        width: '100%',
        panelClass: 'abandon-dialog',
      });
    }
  }

  async validate(): Promise<boolean> {
    this.required = [];
    // Date de rupture correspondant à la date de sortie pour un motif RC
    if (this.formGroup.get('motifSala').value == 'RC' && (this.formGroup.get('postSala').value == 'FALSE' || this.formGroup.get('contRompu').value == 'TRUE')) {
      this.formGroup.get('dateRupt').setValue(this.formGroup.get('dateContSortieSala').value)
    }
    let form = this.formGroup.getRawValue();

    if (this.siretIsValid && !this.buttonSiretIsClicked) {
      await new Promise(resolve => this.getDataFromSiret().subscribe((result) => {
        if (result["error"]) {
          if (!result["error"].includes("503")) {
            resolve(this.setDataEmitter.emit({ var: 'entrepriseInfo', value: "" }));
          }
        } else {
          resolve(this.setDataEmitter.emit({ var: 'entrepriseInfo', value: result }));
        }
      }))
    }
    console.log("form", form, form['motifSala']);
    for (let nameInput in form) {
      let value = form[nameInput] && typeof form[nameInput] === 'string' ? form[nameInput].trim() : form[nameInput];
      if (value == "" || value == "null") {
          (nameInput == "firstnameSala" && (form.isAnonyme == "FALSE" || this.delegation)) ||
          (nameInput == "nameSala" && (form.isAnonyme == "FALSE" || this.delegation)) ||
          (nameInput == "nameEntSala" && (form.isAnonyme == "FALSE" || this.delegation)) ||
          (nameInput == "pseudoSalarie" && (form.isAnonyme == "TRUE" || this.delegation)) ||
          (nameInput == "pseudoEntreprise" && (form.isAnonyme == "TRUE" || this.delegation)) ||
          (nameInput == "civiliteSala") ||
          (nameInput == "dateContSala") ||
          (nameInput == "typeSala") ||
          (nameInput == "postSala") ||
          (nameInput == "motifSala") ||
          (nameInput == "dateContSortieSala" && form["postSala"] == "FALSE") ||
          (nameInput == "contRompu" && form["postSala"] == "TRUE") ||
          (nameInput == "dateRupt" && form["boolRupt"] == "TRUE" && !["RC"].includes(form['motifSala'])) ||
          (nameInput == "maladieSala" && form["postSala"] == "FALSE" && (form['motifSala'] == "LICENCIEMENT ECO" || form['motifSala'] == "LICENCIEMENT PERS")) ||
          (nameInput == "dateMaladieSala" && form['maladieSala'] == "TRUE"  /*&& form["boolRupt"] == "TRUE"*/ && (form['motifSala'] == "LICENCIEMENT ECO" || form['motifSala'] == "LICENCIEMENT PERS")
          ) ? this.required[nameInput] = true : null;
      }
    }
    if (this.dateDiffInDays(new Date(form.dateContSala), new Date()) < 30) {
      this.required["invalidDateContSala"] = true;
      this.required['dateContSala'] = true;
    }
    if (form.dateContSala) {
      let dateNow = new Date()

      let dateContSalaSplit = form.dateContSala.split('-')
      if (new Date(dateContSalaSplit[0], parseInt(dateContSalaSplit[1]) - 1, dateContSalaSplit[2]) > dateNow) {
        this.required['dateContSala'] = true
        this.dateContSalaFalse = true
      } else {
        this.dateContSalaFalse = false

      }
    }

    this.dateRuptFalse = false;
    this.dateSortieFalse = false;
    if (form.dateContSala && form.dateRupt) {
      let entree = new Date(form.dateContSala);
      let rupt = new Date(form.dateRupt);
      if (form.dateContSortieSala) {
        let sortie = new Date(form.dateContSortieSala);
        if (entree > rupt || rupt > sortie) {
          this.required['dateRupt'] = true;
          this.dateRuptFalse = true;
        }
      } else {
        if (entree > rupt) {
          this.required['dateRupt'] = true;
          this.dateRuptFalse = true;
        }
      }
    }
    if (form.dateContSala && form.dateContSortieSala) {
      let entree = new Date(form.dateContSala);
      let sortie = new Date(form.dateContSortieSala);
      if (entree > sortie) {
        this.required['dateContSortieSala'] = true;
        this.dateSortieFalse = true;
      }
    }
    console.log("required",this.required, "dateErr",this.dateErr);
    return Object.keys(this.required).length === 0
      && Object.keys(this.dateErr).length === 0;
  }

  getDataFromSiret() {
    let siret = this.formGroup.get("siret").value;
    let result = new Subject<any>();
    this.subscribe["dataSiret"] = this.appService.getDataFromSiret(siret).subscribe(
      (res) => {
        result.next(res.result);
      }
    )
    return result.asObservable();
  }

  dateDiffInDays(dateA, dateB) {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utc1 = Date.UTC(dateA.getFullYear(), dateA.getMonth(), dateA.getDate());
    const utc2 = Date.UTC(dateB.getFullYear(), dateB.getMonth(), dateB.getDate());

    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }

  openDialogDocuments() {
    this.actionEmitter.emit({ action: "doc" });
  }

  changeStep() {
    this.actionEmitter.emit({ action: "step" });
  }

  seeRapport() {
    this.actionEmitter.emit({ action: "rapport", data: "dashboard" });
  }



}
